(() => {
    class CollectionColorsSwatches extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.nextButton = this.querySelector('.collection-colors-swatches__next');
        this.prevButton = this.querySelector('.collection-colors-swatches__prev');
        this.sliderEl = this.querySelector('.collection-colors-swatches__slider');
  
        // Parent card + primary image
        const card = this.closest('.collection-product-card');
        this.primaryImg = card?.querySelector('.collection-product-card__image-primary img') || null;
  
        // Title bits (optional)
        this.colorTitle = card?.querySelector('.collection-product-card__title') || null;
        this.colorTitleText = this.colorTitle?.textContent || '';
  
        // Remember original image attrs
        this.original = this.primaryImg ? {
          src: this.primaryImg.getAttribute('src'),
          srcset: this.primaryImg.getAttribute('srcset'),
          sizes: this.primaryImg.getAttribute('sizes'),
          alt: this.primaryImg.getAttribute('alt')
        } : null;
  
        // Binds
        this.handleResize = this.handleResize.bind(this);
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
  
        this.isInteracting = false;
      }
  
      connectedCallback() {
        this.initSlider();
        this.updateSwiperHeightVar(this.sliderEl);   // ✅ height var
        this.addDelegatedListeners();
        window.addEventListener('resize', this.handleResize);
      }
  
      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        this.removeDelegatedListeners();
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
  
      handleResize() {
        this.updateSwiperHeightVar(this.sliderEl);   // ✅ on resize
      }
  
      updateSwiperHeightVar(containerEl) {
        if (!containerEl) return;
        const finalHeight = containerEl.offsetHeight + 16;
        this.style.setProperty('--swiper-max-height', `${finalHeight}px`);
      }
  
      initSlider() {
        if (this.swiper || !this.sliderEl) return;
  
        this.swiper = new Swiper(this.sliderEl, {
          loop: true,
          rewind: false,
          speed: 500,
          spaceBetween: 0,
  
          // View + grouping
          slidesPerView: 3,
          slidesPerGroup: 1,
          loopAdditionalSlides: 1,
  
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.prevButton
          },
  
          on: {
            touchStart: () => { this.isInteracting = true; },
            touchEnd:   () => { this.isInteracting = false; }
          }
        });
      }
  
      addDelegatedListeners() {
        if (!this.sliderEl) return;
        this.sliderEl.addEventListener('mouseover', this.onMouseOver);
        this.sliderEl.addEventListener('mouseout', this.onMouseOut);
        this.sliderEl.addEventListener('focusin', this.onFocusIn);
        this.sliderEl.addEventListener('focusout', this.onFocusOut);
      }
      removeDelegatedListeners() {
        if (!this.sliderEl) return;
        this.sliderEl.removeEventListener('mouseover', this.onMouseOver);
        this.sliderEl.removeEventListener('mouseout', this.onMouseOut);
        this.sliderEl.removeEventListener('focusin', this.onFocusIn);
        this.sliderEl.removeEventListener('focusout', this.onFocusOut);
      }
  
      onMouseOver(e) {
        if (this.isInteracting) return;
        const slide = e.target.closest('.swiper-slide');
        if (!slide || !this.sliderEl.contains(slide)) return;
        this.applySlidePreview(slide);
      }
      onMouseOut(e) {
        const to = e.relatedTarget;
        if (!to || !this.sliderEl.contains(to)) this.resetPreview();
      }
      onFocusIn(e) {
        const slide = e.target.closest('.swiper-slide');
        if (!slide || !this.sliderEl.contains(slide)) return;
        this.applySlidePreview(slide);
      }
      onFocusOut(e) {
        const to = e.relatedTarget;
        if (!to || !this.sliderEl.contains(to)) this.resetPreview();
      }
  
      applySlidePreview(slide) {
        if (!this.primaryImg) return;
        const rawUrl = slide.dataset.image;
        const imgColorTitle = slide.dataset.title;
        if (!rawUrl) return;
  
        if (imgColorTitle && this.colorTitle) {
          this.colorTitle.textContent = imgColorTitle;
        }
  
        const widths = [352, 800];
        const src = this.withWidthParam(rawUrl, 800);
        const srcset = widths.map(w => `${this.withWidthParam(rawUrl, w)} ${w}w`).join(', ');
  
        this.primaryImg.setAttribute('src', src);
        this.primaryImg.setAttribute('srcset', srcset);
        if (!this.primaryImg.getAttribute('sizes')) {
          this.primaryImg.setAttribute('sizes', '(max-width: 800px) 100vw, 800px');
        }
      }
  
      resetPreview() {
        if (!this.primaryImg || !this.original) return;
        this.primaryImg.setAttribute('src', this.original.src || '');
        if (this.original.srcset) {
          this.primaryImg.setAttribute('srcset', this.original.srcset);
        } else {
          this.primaryImg.removeAttribute('srcset');
        }
        if (this.original.sizes) {
          this.primaryImg.setAttribute('sizes', this.original.sizes);
        } else {
          this.primaryImg.removeAttribute('sizes');
        }
        if (this.colorTitle) this.colorTitle.textContent = this.colorTitleText || '';
      }
  
      withWidthParam(url, width) {
        try {
          const fixed = url.startsWith('//') ? (location.protocol + url) : url;
          const u = new URL(fixed);
          if (u.searchParams.has('width')) {
            u.searchParams.set('width', String(width));
          } else {
            u.searchParams.append('width', String(width));
          }
          return u.href.replace(location.protocol, '');
        } catch {
          const sep = url.includes('?') ? '&' : '?';
          return `${url}${sep}width=${width}`;
        }
      }
    }
  
    customElements.define('collection-colors-swatches', CollectionColorsSwatches);
  })();
  